import React from "react";

/** "Shared phone number · N linked records" — only when more than one record shares the number. */
const SharedNumberChip: React.FC<{ count: number }> = ({ count }) =>
  count > 1 ? (
    <span className="inline-flex items-center rounded-full border border-amber-300 bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-900">
      Shared phone number · {count} linked records
    </span>
  ) : null;

export default SharedNumberChip;
